import React from 'react';
import { Spin } from 'antd';

export interface DashboardRunAiBlockedStatusProps {
    message: string | null;
}

/** Inline status shown while Run AI is disabled during site or production calculations. */
export function DashboardRunAiBlockedStatus({ message }: DashboardRunAiBlockedStatusProps) {
    if (!message) return null;

    return (
        <div className="obd-ai-rail__run-blocked-status" role="status" aria-live="polite">
            <Spin size="small" aria-hidden />
            <span>{message}</span>
        </div>
    );
}
